export default __webpack_public_path__ + "static/media/self-review-img.5c3a9754.svg";